import { ThreeDotsLoader } from "../../../../../../../components";
import styles from "./card-subtitle.module.scss";

type Props = {
  label?: string | null;
};

const Analyzing = ({ label }: Props) => (
  <div
    className={styles.analyzing}
    data-testid="report_summary_subheader_analyzing_indicator"
  >
    <span>{label ?? "Analyzing"}</span>
    <ThreeDotsLoader height={6} />
  </div>
);

export default Analyzing;
